import { fabric } from "fabric"

let images: ImageMap = {}

export const clearLoadedImages = () => {
  images = {}
}

export default abstract class WithImages {
  protected lastImage: HTMLImageElement

  get imagesLoaded() {
    const paths = this.imagePaths()

    if (paths === null) {
      return true
    }

    if (Array.isArray(paths)) {
      return paths.every(path => !!images[path])
    }

    return !!this.lastImage
  }

  loadImages(imagePath?: string) {
    const path = imagePath || this.imagePaths()

    if (Array.isArray(path)) {
      for (const url of path) {
        this.loadImages(url)
      }

      return
    }

    if (path) {
      if (images[path]) {
        this.lastImage = images[path]
        return
      }

      fabric.util.loadImage(path, img => {
        this.lastImage = img
        images[path] = img
        this.redraw()
      })
    }
  }

  protected abstract redraw(): void

  protected image(end?: string) {
    if (!end) {
      return this.lastImage
    }

    for (const path in images) {
      if (images[path]) {
        const img = images[path]

        if (path.endsWith(end)) {
          return img
        }
      }
    }

    return null
  }

  protected imagePaths(): string | string[] | null {
    return null
  }
}
